import { useMutation, useQueryClient } from "@tanstack/react-query";
import ms from "ms";
import getFundingAccount from "../requests/getFundingAccount";
import setFundingAccount from "../requests/setFundingAccount";
import { externalAccountsKeyMaker } from "./useExternalAccounts";
import { fundingAccountKeyMaker } from "./useFundingAccount";
export default function useSetFundingAccount(config) {
    const queryClient = useQueryClient();
    const mutation = useMutation({
        mutationFn: async (input) => {
            if (config === null) {
                throw new Error("no auth");
            }
            await setFundingAccount(input.accountId, input.attachment ?? null, config);
            let resolveMutation = () => undefined;
            let _rejectMutation = () => undefined;
            /* The BE runs this operation asynchronously and while it is being set the BE returns `null`.
                On the UI we do not want to show an empty FA so we would like to wait for the eventual consistency
                 to resolve. We wait up to 12 seconds for this.
            */
            const eventualConsistencyPromise = new Promise((resolve, reject) => {
                resolveMutation = resolve;
                _rejectMutation = reject;
            });
            const waitTime = ms("3sec");
            let totalTime = 0;
            const interval = setInterval(async () => {
                totalTime = totalTime + waitTime;
                if (totalTime >= ms("12sec")) {
                    clearInterval(interval);
                    resolveMutation();
                }
                const fundingAccount = await getFundingAccount(config);
                if (fundingAccount.account !== null) {
                    clearInterval(interval);
                    resolveMutation();
                    return;
                }
                // go for another loop
            }, waitTime);
            return eventualConsistencyPromise;
        },
        onSuccess: () => {
            queryClient.invalidateQueries({
                queryKey: fundingAccountKeyMaker(),
            });
            queryClient.invalidateQueries({
                queryKey: externalAccountsKeyMaker(),
            });
        },
    });
    return mutation.mutateAsync;
}
//# sourceMappingURL=useSetFundingAccount.js.map